import { Button } from "@/shared/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Input } from "@/shared/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select";
import { useEffect, useState } from "react";

export function TmsTokenCreateDialog({
    open,
    onOpenChange,
    channels,
    currentChannel,
    schemaFields,
    onChangeChannel,
    onSubmit,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    channels: string[];
    currentChannel: string;
    schemaFields: string[];
    onChangeChannel: (channel: string) => void;
    onSubmit: (payload: { channel: string; fields: Record<string, string> }) => Promise<void> | void;
}) {
    const [fields, setFields] = useState<Record<string, string>>({});

    useEffect(() => {
        if (!open) return;
        setFields({});
    }, [open, currentChannel]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>
                    <DialogTitle>TMS 토큰 추가</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <div className="flex items-center gap-2">
                        <div className="text-sm">채널:</div>
                        <Select value={currentChannel} onValueChange={onChangeChannel}>
                            <SelectTrigger className="w-[240px]">
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                {channels.map((c) => (
                                    <SelectItem key={c} value={c}>
                                        {c}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>

                    <div className="grid gap-3">
                        {schemaFields.map((f) => (
                            <div key={f} className="grid gap-1">
                                <div className="text-sm font-medium">{f}</div>
                                <Input
                                    value={fields[f] ?? ""}
                                    onChange={(e) => setFields((p) => ({ ...p, [f]: e.target.value }))}
                                    className="w-[320px]"
                                    name={f}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <DialogFooter>
                    <Button variant="ghost" onClick={() => onOpenChange(false)}>
                        취소
                    </Button>
                    <Button
                        onClick={async () => {
                            await onSubmit({ channel: currentChannel, fields });
                            onOpenChange(false);
                        }}
                        disabled={!currentChannel}
                    >
                        추가
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}